import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginModal from "../../loginModal/LoginModal";
import CrdzAddToCartModal from "../addToCartModal/CrdzAddToCartModal";
import SnackBarComponent from "../snackbar/snackbar";


const HEIGHT = window.innerHeight;
const WIDTH = window.innerWidth;

class ProductRelations {
  "productRelationId": number;
  "productId": number;
  "relatedProductId": number;
  "slimProduct": {
    "productId": number;
    "productName": string;
    "productImageUrl": string;
    "mrpPrice": number;
    "taxPercent": number,
    "salePrice": number,
    "productDiscount": any,
    "availableQuantity": number
  }
}
interface PriceDetails {
  mrpPrice: number;
  taxPercent: number;
  saleWarranty: number;
  salePrice: number;
  productDiscount: any | null;
}

const PriceSection: React.FC<any> = ({ prop, pass, comboList, installationService, handleAddToCart, disableAddToCart, quantity, setQuantity }) => {
  const [productObj, setProductObj] = useState(pass);

  const [disableAddToCartInPrice, setDisableAddToCart] = useState(disableAddToCart);
  const [priceDetails, setPriceDetails] = useState<PriceDetails>({
    mrpPrice: 0,
    taxPercent: 0,
    saleWarranty: 0,
    salePrice: 0,
    productDiscount: null
  });
  const [open, setOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);

  const handleClickListItem = () => {
    if (localStorage.getItem("token")) {
      setOpen(true);
    } else {
      setLoginOpen(true);
    }

  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLoginClose = () => {
    setLoginOpen(false);
  }


  const [totalPrice, setTotalPrice] = useState<any>(0);

  const handleQuantityChange = (event: SelectChangeEvent<number>) => {
    let selectedQuantity = Number(event.target.value);
    setQuantity(selectedQuantity);
    checkAvailability(selectedQuantity);
  };

  const checkAvailability = (selectedQuantity: number) => {
    const isProductOutOfStock = productObj && productObj.availableQuantity < selectedQuantity;
    const isComboOutOfStock = comboList && comboList.some((combo: any) => combo.product.availableQuantity < selectedQuantity);
    console.log(isProductOutOfStock, isComboOutOfStock);
    setDisableAddToCart(isProductOutOfStock || isComboOutOfStock);
  };

  const calculateTotalPrice = () => {
    let itemPrice = productObj.salePrice + (productObj.salePrice * productObj.taxPercent) / 100;
    let finalPrice = itemPrice;
    if (comboList && comboList.length > 0) {
      let comboPrice = comboList.reduce((sum: any, combo: any) => sum + combo.totalPrice, 0);
      finalPrice = finalPrice + comboPrice;
      //Disable add to cart button if any of the related product is out of stock
      checkAvailability(quantity);

    }
    if (installationService) {
      let servicePrice = installationService.totalPrice;
      finalPrice = finalPrice + servicePrice;
    }
    setTotalPrice(parseFloat(finalPrice).toFixed(2));
  }

  useEffect(() => {
    if (productObj) {
      setPriceDetails({
        mrpPrice: productObj.mrpPrice || 0,
        taxPercent: productObj.taxPercent || 0,
        saleWarranty: productObj.saleWarranty || 0,
        salePrice: productObj.salePrice || 0,
        productDiscount: productObj.productDiscount || null
      });
      if (productObj.availableQuantity <= 0) {
        setDisableAddToCart(true);
      }
      else {
        setDisableAddToCart(false);
      }
    }
    calculateTotalPrice();
  }, [productObj, comboList, installationService]);

  return (
    <Card>
      <CardContent>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{
              textDecoration: priceDetails.productDiscount ? 'line-through' : 'none',
              marginRight: '8px',
            }}
          >
            MRP ${priceDetails.mrpPrice}
          </Typography>
          {priceDetails.productDiscount && priceDetails.productDiscount.discountType == 'PERCENTAGE' &&
            <Typography variant="subtitle2" color="success">
              {priceDetails.productDiscount.discountValue}% OFF
            </Typography>
          }
          {priceDetails.productDiscount && priceDetails.productDiscount.discountType == 'FIXED_AMOUNT' &&
            <Typography variant="subtitle2" color="success">
              ${priceDetails.productDiscount.discountValue} OFF
            </Typography>
          }
        </div>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant="h6"
            gutterBottom style={{ fontWeight: 'bold' }}
            color="error"
            sx={{
              marginRight: '8px',
            }}
          >
            ${priceDetails.salePrice}
          </Typography>
          <Typography variant="subtitle2" gutterBottom color="primary">
            + {priceDetails.taxPercent}% GST
          </Typography>
        </div>

        {/* <Typography variant="h6" color="error" >
          ${priceDetails.salePrice}
        </Typography> */}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {/* <Typography variant="body2" color="primary">
              GST{" "}
              {priceDetails.taxPercent ? `${priceDetails.taxPercent}%` : "-"}
            </Typography> */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="h4"
                color="primary"
                sx={{
                  fontWeight: "bold",
                  color:'#0f456c'
                }}
              >
                ${totalPrice || "-"}
              </Typography>
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="subtitle2" color="textSecondary">
                (GST inclusive price)
              </Typography>
            </Box>
          </Grid>

          {/* <Grid item xs={12}>
            <Typography variant="body2" color="success" sx={{ ml: 1 }}>
              SaleWarranty {priceDetails.saleWarranty || "-"}
            </Typography>
            <Typography
              variant="h4"
              color="primary"
              sx={{
                fontWeight: "bold",
              }}
            >
              ${totalPrice || "-"}
            </Typography>
          </Grid> */}
        </Grid>

        <Divider sx={{ my: 2 }} />
        {/* <Box display="flex" alignItems="center">
          <IconButton onClick={handleDecrease} disabled={quantity <= 1}>
            <RemoveIcon />
          </IconButton>
          <TextField
            value={quantity}
            onChange={(e) => setQuantity(Number(e.target.value))}
            type="number"
            inputProps={{ min: 1, max: 20 }}
            variant="outlined"
            size="small"
            sx={{ width: 50, textAlign: 'center' }}
          />
          <IconButton onClick={handleIncrease} disabled={quantity >= 20}>
            <AddIcon />
          </IconButton>
        </Box> */}
        <Typography variant="subtitle2" color={disableAddToCartInPrice ? "red" : "green"}>
          {disableAddToCartInPrice ? "Out of Stock" : "In Stock"}
        </Typography>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={3}>
            <Select
              value={quantity}
              onChange={handleQuantityChange}
              size="small"
            >
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={5}>5</MenuItem>
            </Select>
          </Grid>
          {/* <Grid item xs={4}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleBuyNow}
            >
              Buy Now
            </Button>
          </Grid> */}
          <Grid item xs={9}>
            <Button
              variant="contained"
              //color="error"
              style={{ backgroundColor: '#0a3150', color: 'white' }}
              fullWidth
              onClick={handleClickListItem}
              disabled={disableAddToCartInPrice}
            >
              Add to Cart
            </Button>
            <LoginModal open={loginOpen}
              onClose={handleLoginClose} />
            <CrdzAddToCartModal
              productObj={productObj}
              quantity={quantity}
              comboList={comboList}
              installationService={installationService}
              handleAddToCart={handleAddToCart}
              id="ringtone-menu"
              keepMounted
              open={open}
              onClose={handleClose}
            />
            {/* <CrdzAddToCartDropdown productObj={productObj} quantity={quantity} comboList={comboList} installationService={installationService}
              handleAddToCart={handleAddToCart} /> */}
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />
      </CardContent>
    </Card>
  );
};

const EssentialCombo: React.FC<any> = ({ productObj, addCombo, removeCombo, comboList, quantity }) => {
  const handleCheckbox = async (e: any, item: any, index: number) => {
    let isExists = false;
    if (comboList && comboList.length > 0) {
      let combo = comboList.find((x: any) => x.product.productId == item.slimProduct.productId);
      isExists = combo ? true : false;
    }
    if (!isExists) {
      let unitPrice = item.slimProduct.salePrice ? item.slimProduct.salePrice : 0;
      let cartItem = {
        product: {
          productId: item.slimProduct.productId,
          productName: item.slimProduct.productName,
          salePrice: item.slimProduct.salePrice ? item.slimProduct.salePrice : 0,
          availableQuantity: item.slimProduct.availableQuantity
        },
        quantity: 1,
        unitPrice: unitPrice,
        totalPrice: (unitPrice + (unitPrice * item.slimProduct.taxPercent) / 100),
      };
      addCombo(cartItem);
    } else {
      removeCombo(item.slimProduct.productId);
    }
  };
  return (
    <Card>
      <CardHeader title={
        <Typography variant="h6" sx={{ color: "white", fontWeight: "bold" }}>
          Essential Combos
        </Typography>
      }
        sx={{
          //background: "linear-gradient(to right, rgb(94 89 89), rgb(170 127 124))",
          //"linear-gradient(to right, rgb(246 24 24), rgb(244 129 121))",
          background: "linear-gradient(to right, rgb(195 40 32), rgb(221 121 116))",
          borderBottom: "1px solid #ccc",
          padding: "10px 16px",
          textAlign: "center",
        }} />
      <CardContent>
        <List>
          {productObj &&
            productObj.productRelations &&
            productObj.productRelations.length !== 0 ? (
            productObj.productRelations.map(
              (
                item: ProductRelations,
                index: number
              ) => (
                <ListItem style={{
                  // marginLeft: (-WIDTH * 1.5) / 100,
                  paddingLeft: 0,
                  paddingTop: 0
                }}>
                  <Checkbox size="small" defaultChecked onClick={(e: any) => handleCheckbox(e.target.value, item, index)} />
                  <ListItemAvatar>
                    <Avatar src={item.slimProduct.productImageUrl} />{" "}
                  </ListItemAvatar>
                  <ListItemText sx={{
                    "& .MuiListItemText-primary": {
                      fontSize: '13px',
                      fontWeight: 'bold'
                    },
                    "& .MuiListItemText-secondary": {
                      fontSize: '11px',
                    }
                  }}
                    primary={item.slimProduct.productName}
                    secondary={
                      <>
                        {item.slimProduct.productDiscount ? (
                          <>
                            <span style={{ textDecoration: "line-through", color: "gray" }}>
                              ${item.slimProduct.mrpPrice ? item.slimProduct.mrpPrice : 0.00}
                            </span>{" "}
                            <span style={{ marginLeft: "5px", fontWeight: "bold", color: "green" }}>
                              ${item.slimProduct.salePrice ? item.slimProduct.salePrice : 0.00}
                            </span>
                          </>
                        ) : (
                          <span style={{ marginLeft: "5px", fontWeight: "bold", color: "green" }}>
                            ${item.slimProduct.salePrice ? item.slimProduct.salePrice : 0.00}
                          </span>
                        )}
                        {quantity > item.slimProduct.availableQuantity ? (
                          <span style={{ color: "red" }}> (Out of Stock)</span>
                        ) : (
                          <></>
                        )}
                      </>
                    }
                  />
                </ListItem>
              )
            )
          ) : ""}
        </List>
      </CardContent>

    </Card>
  )
};

const InstallationServices: React.FC<any> = ({ productObj, serviceProduct, addInstallationService, removeInstallationService }) => {
  const handleCheckbox = async (e: any) => {
    if (serviceProduct) {
      removeInstallationService();
    } else {
      addInstallationService();
    }
  };
  return <>
    <Card>
      <CardHeader title={
        <Typography variant="h6" sx={{ color: "white", fontWeight: "bold" }}>
          Installation Services
        </Typography>
      }
        sx={{
          // background: "linear-gradient(to right, rgb(246 24 24), rgb(244 129 121))",
          background: "linear-gradient(to right, rgb(10 50 83), rgb(102 136 160))",
          borderBottom: "1px solid #ccc",
          padding: "10px 16px",
          textAlign: "center",
        }} />
      <CardContent>
        <List>
          {productObj && productObj.serviceProduct ? (
            <ListItem style={{
              // marginLeft: (-WIDTH * 1.5) / 100,
              paddingLeft: 0,
              paddingTop: 0
            }}>
              <Checkbox size="small" defaultChecked onClick={(e: any) => handleCheckbox(e.target.value)} />
              <ListItemAvatar>
                <Avatar src={productObj.serviceProduct.productImageUrl} />{" "}
                {/* Replace with actual image URL */}
              </ListItemAvatar>
              <ListItemText sx={{
                "& .MuiListItemText-primary": {
                  fontSize: '13px',
                  fontWeight: 'bold'
                },
                "& .MuiListItemText-secondary": {
                  fontSize: '13px',
                }
              }}
                primary={productObj.serviceProduct.productName}
                secondary={
                  <>
                    {productObj.serviceProduct.productDiscount ? (
                      <>
                        <span style={{ textDecoration: "line-through", color: "gray" }}>
                          ${productObj.serviceProduct.mrpPrice ? productObj.serviceProduct.mrpPrice : 0.00}
                        </span>{" "}
                        <span style={{ marginLeft: "5px", fontWeight: "bold", color: "green" }}>
                          ${productObj.serviceProduct.salePrice ? productObj.serviceProduct.salePrice : 0.00}
                        </span>
                      </>
                    ) : (
                      <span style={{ marginLeft: "5px", fontWeight: "bold", color: "green" }}>
                        ${productObj.serviceProduct.salePrice ? productObj.serviceProduct.salePrice : 0.00}
                      </span>
                    )}
                  </>
                }
              />
            </ListItem>
          ) : ""}
        </List>
      </CardContent>
    </Card>
  </>
};

const DetailPageSide: React.FC<{ pass: any }> = ({ pass }) => {
  const [comboList, setComboList] = useState<any[]>([]);
  const [installationService, setInstallationService] = useState<any>();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const history = useNavigate();
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    if (pass.productRelations && pass.productRelations.length > 0) {
      let comboItems: any[] = [];
      pass?.productRelations?.forEach((item: any) => {
        comboItems.push({
          product: {
            productId: item.slimProduct.productId,
            productName: item.slimProduct.productName,
            salePrice: item.slimProduct.salePrice,
            availableQuantity: item.slimProduct.availableQuantity
          },
          quantity: 1,
          unitPrice: item.slimProduct.mrpPrice,
          totalPrice: (item.slimProduct.salePrice + (item.slimProduct.salePrice * item.slimProduct.taxPercent) / 100),
        })
      })
      setComboList(comboItems);
    }
    if (pass.serviceProduct) {
      setInstallationService(getServiceProduct());
    }
  }, []);

  const getServiceProduct = () => {
    if (pass.serviceProduct) {
      let unitPrice = pass.serviceProduct.salePrice ? pass.serviceProduct.salePrice : 0;
      return {
        product: {
          productId: pass.serviceProduct.productId,
          productName: pass.serviceProduct.productName,
          salePrice: pass.serviceProduct.salePrice ? pass.serviceProduct.salePrice : 0,
        },
        quantity: 1,
        unitPrice: unitPrice,
        totalPrice: (unitPrice + (unitPrice * pass.serviceProduct.taxPercent) / 100),
      };
    }
  }

  const addInstallationService = () => {
    setInstallationService(getServiceProduct());
  }

  const removeInstallationService = () => {
    setInstallationService(null);
  }

  const addCombo = async (cartItem: any) => {
    setComboList([...comboList, cartItem]);
  }

  const removeCombo = async (productId: number) => {
    let index = comboList.findIndex((item: any) => item.product.productId == productId);
    const updatedList = comboList.filter((_, i) => i !== index);
    setComboList(updatedList);
  }

  const handleNavigation = (path: string) => {
    history(path);
  };

  const handleAddToCart = (message: string) => {
    setMessage(message);
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 2500);
  }

  return WIDTH < 400 ? (
    <Box maxWidth="sm">
      <Card
        sx={{ mb: 4 }}
        style={{ borderRadius: 10, }}
      >
        <PriceSection prop={handleNavigation} pass={pass} comboList={comboList} installationService={installationService}
          handleAddToCart={handleAddToCart} />
        {pass && pass.productRelations && pass.productRelations.length > 0 &&
          <EssentialCombo addCombo={addCombo} removeCombo={removeCombo} productObj={pass} comboList={comboList} />
        }
        {pass && pass.serviceProduct &&
          <InstallationServices productObj={pass} serviceProduct={installationService} addInstallationService={addInstallationService} removeInstallationService={removeInstallationService} />
        }
        {open && <SnackBarComponent showButton={"true"} message={message} />}
        {/* <AddToCartButton /> */}
      </Card>
    </Box>
  ) : (
    <Container maxWidth="xl" sx={{ padding: 0 }}>
      <Card
        sx={{
          mt: 2,
          backgroundColor: 'white',
          // border: '1px solid rgba(0, 0, 0, 0.1)',
          boxShadow: 'none'
          //boxShadow: '10px 10px 8px rgba(0, 0, 0, 0.15), -2px -2px 5px rgba(255, 255, 255, 0.6)'
        }}
        style={{ borderRadius: 3 }}
      >
        <PriceSection prop={handleNavigation} pass={pass} comboList={comboList} installationService={installationService}
          handleAddToCart={handleAddToCart} quantity={quantity} setQuantity={setQuantity} />
      </Card>

      {pass && pass.productRelations && pass.productRelations.length > 0 &&
        <>
          <Card
            sx={{
              mt: 2,
              backgroundColor: 'white',
              boxShadow: 'none'
              // border: '1px solid rgba(0, 0, 0, 0.1)',
              //boxShadow: '10px 10px 8px rgba(0, 0, 0, 0.15), -2px -2px 5px rgba(255, 255, 255, 0.6)'
            }}
            style={{ borderRadius: 3 }}
          >

            <EssentialCombo addCombo={addCombo} removeCombo={removeCombo} productObj={pass} comboList={comboList} quantity={quantity} />
          </Card>
        </>
      }

      {pass && pass.serviceProduct &&
        <>
          <Card
            sx={{
              mt: 2,
              backgroundColor: 'white',
              // border: '1px solid rgba(0, 0, 0, 0.1)',
              boxShadow: 'none'
              //boxShadow: '10px 10px 8px rgba(0, 0, 0, 0.15), -2px -2px 5px rgba(255, 255, 255, 0.6)'
            }}
            style={{ borderRadius: 3 }}
          >

            <InstallationServices productObj={pass} serviceProduct={installationService} addInstallationService={addInstallationService} removeInstallationService={removeInstallationService} />
          </Card>
        </>
      }
      {open && <SnackBarComponent showButton={"true"} message={message} />}
    </Container>
  );
};

export default DetailPageSide;
